import { render } from "./AlbumListing.vue?vue&type=template&id=0412f6b5&scoped=true"
import script from "./AlbumListing.vue?vue&type=script&lang=ts"
export * from "./AlbumListing.vue?vue&type=script&lang=ts"

import "./AlbumListing.vue?vue&type=style&index=0&id=0412f6b5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0412f6b5"

export default script